import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as appActions from "../../../core/app.store";
import * as InitMapStore from '../../../redux/store/init-map/init-map.store';
import * as mapAction from "../../../redux/store/planning-map/planning-map.store";

function ShowHideMap(props) {
    const { is_active, mapSetting } = props;
    const [isActive, setIsActive] = useState(is_active);

    // const setActiveMap = (_is_active = is_active) => {
    //     props.UpdateMapSetting({ ...mapSetting, is_active: !_is_active })
    // }
    const ActiveMap = (id = props.mapId) => {
        mapAction.ActiveMapById(id).then((res) => {
        })
    }

    const DeactiveMap = (id = props.mapId) => {
        mapAction.DeActiveMapById(id).then((res) => {
        })
    }
    const setActiveMap = () => {
        ActiveMap();
        setIsActive(!isActive)
    }
    const setDeactiveMap = () => {
        DeactiveMap();
        setIsActive(!isActive)
    }
    return (

        isActive ? (<Button color="inherit" onClick={() => setDeactiveMap()}>
            Ẩn bản đồ
        </Button>) : (<Button color="inherit" onClick={() => setActiveMap()}>
            Hiện bản đồ
        </Button>)

    )
}

const mapStateToProps = state => ({
    initMap: state.initMap
})

const mapDispatchToProps = dispatch => bindActionCreators({
    showLoading: appActions.ShowLoading,
    UpdateMapSetting: InitMapStore.UpdateMapSetting
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ShowHideMap)